export function formatCPF(cpf: string) {
	cpf = cpf.replace(/[^\d]/g, '')

	return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
}

export function formatPhone(phone: string) {
	phone = phone.replace(/[^\d]/g, '')
	phone = phone.slice(0, 11)

	if (phone.length <= 10) {
		return phone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3')
	} else {
		return phone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
	}
}

export function numberFixed(value: number) {
	return value.toFixed(2)
}

export const formatter = new Intl.NumberFormat('pt-br', {
	style: 'currency',
	currency: 'BRL',
	minimumFractionDigits: 2,
})
